<template>
  <div id="app" :class="'view--' + $route.name">
	  
    <article id="initial" class="page active" @click="pageLink('/')">
      <section class="table relative"><div class="table-cell">
        <h1>Benjamin <br/><strong>Pöntinen</strong></h1>
        
        <div class="initial-currently">
          <template v-for="(item,index) in current">
	          <transition appear name="fade">
            <div class='text-mono'>
            <a :data-title="item.current_title" @click="nullClick" @mouseover="mouseOver(sanitizeTitle(item.current_title).toString())" @mouseout="active = null">{{ item.current_title }}</a>
            </div>
            </transition>
          </template>
        </div>

        <div class="initial-contact text-right">
          <contact/>
        </div>
        
      </div></section>
    </article>
		
    <page v-for="(item, index) in pages" class="page" :key="item.id" :index="index+1" :page_id="item.page" />
		
    <router-view/>

    <currently v-for="(item, index) in current" :key="item.id" :currently="item" v-if="active == sanitizeTitle(item.current_title).toString()"/>
    
    <transition appear name="fade">
	    <a :href="dot" target="_blank">
    <aside class="dot external"></aside>
	    </a>
    </transition>
  </div>
</template>

<script>
import Page from './components/Page.vue'
import Contact from './components/Contact.vue'
import Currently from './components/Currently.vue'

export default {
  name: 'App',
  components: {
	  Page,
    Contact,
    Currently
  },
  data () {
	  return {
		  uid: null,
		  title: null,
		  description: null,
		  pages: [],
		  current: [],
      active: null,
      dot: null
	  }
  },
  metaInfo () {
	  function humanizeSlug(slug) {
	    if (slug != null) {
	    var frags = slug.split('-');
	    var i;
	    for (i=0; i<frags.length; i++) {
		    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
		  }
		  return frags.join(' ');
		  } else { return "" };
    }
    
	  return {
		  title: this.$route.name !== 'home' ? humanizeSlug(this.$route.name) : 'Benjamin Pöntinen',
	    meta: [
	      { name: 'description', content: 'Benjamin Pöntinen is a Paris-based marketing and entrepreneurship expert. He is the CEO of The Community, an art institute, think tank and creative consultancy.' }
	    ]
	  }  
  },
  methods: {
	  pageLink (route) {
		  this.$router.push(route)
	  },
	  nullClick () {
		  return false
	  },
	  getContent () {
		  this.$prismic.client.getSingle('site')
		  	.then((document) => {
			  	this.uid = document.data.uid
			  	this.title = document.data.title;
			  	this.description = document.data.description;
			  	this.dot = document.data.dot.url;
			  	this.pages = document.data.pages;
			  	this.current = document.data.current;
		  	})
	  },
	  sanitizeTitle (title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
      // Letter "d"
      slug = slug.replace(/đ/gi, 'd');
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, '');
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, '-');
      
      return slug;
    },
    mouseOver(uid) {
	    console.log(uid);
     return this.active = uid;   
    }
  },
  created () {
	  this.getContent();
  },
  mounted () {

    $('#initial').addClass('loaded');
  
  }
}
</script>

<style>
@import "./assets/css/prismic-edit-button.css";
@import "./assets/css/legend.css?v=2";

.fade-enter-active, .fade-leave-active {
  transition: opacity 333ms cubic-bezier(0.57, 0.06, 0.05, 0.95);
  transition-delay: 1.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.dot.external {
	width: 32px;
  height: 32px;
  background-color: #000;
  border-radius: 32px;
  cursor: pointer;
  position: absolute;
  right: 4.5vw;
  bottom: 4.5vw;
  transition: transform .25s cubic-bezier(.57,.06,.05,.95);
  z-index: 999;
  display: block;
 
}

@media only screen and (max-width: 1030px) {
  .dot.external { margin-bottom: 243px;margin-right: 12px;}

}

.dot.external:hover {
	  transform: scale(1.25);
  }


</style>

